import { SagaIterator } from 'redux-saga'
import { select, put, call, takeEvery } from 'redux-saga/effects'
import {
  getCategoryDropdownData,
  updateCategoryDropdownData,
} from '../slices/categoryDropdown.slice'
import { PayloadAction } from '@reduxjs/toolkit'
import { getCategoryDropdownOptions } from '../apis'

function* fetchCategoryDropdownData(
  action: PayloadAction<string>
): SagaIterator {
  try {
    const categoryKey = action.payload
    const isLoading = yield select((state) => state?.categoryDropdown?.loading)
    const data = yield select((state) => state?.categoryDropdown?.categoryMap)

    if (data?.[categoryKey] || isLoading) return

    const response = yield call(getCategoryDropdownOptions, categoryKey)
    yield put(
      updateCategoryDropdownData({
        categoryKey,
        options: response.data
          .map((val: { id: number; value: string }) => ({
            value: val.value,
            id: val.id,
          }))
          .sort(
            (
              a: { id: number; value: string },
              b: { id: number; value: string }
            ) => a.value.localeCompare(b.value)
          ),
      })
    )
  } catch (err) {
    if ((err as { message: string })?.message?.includes('500'))
      yield put(
        updateCategoryDropdownData({
          categoryKey: action.payload,
          options: [],
        })
      )
    console.error(err)
  }
}

export function* watchFetchCategoryDropdown() {
  yield takeEvery(getCategoryDropdownData.type, fetchCategoryDropdownData)
}
